import React from 'react';
import StaticPageHeader from '../components/common/StaticPageHeader';
import useMerchantSettings from '../hooks/useMerchantSettings';
import { errorView, loadingView } from '../utils/Utilities';
import { Helmet } from 'react-helmet-async';
import '../assets/css/allpages.css';

const TermsConditions = () => {
    const { merchantSettings, loading, error } = useMerchantSettings();
    const currentOrigin = typeof window !== 'undefined' ? window.location.origin : '';
    const storeName = merchantSettings?.legal_name || 'Online Store';

    return (
        <div className="static-page-wrapper">
            <Helmet>
                <title>{`Terms & Conditions | ${storeName}`}</title>
                <meta name="description" content={`Read the terms and conditions for shopping at ${storeName}. Review store policies and order guidelines.`} />
                {currentOrigin && <link rel="canonical" href={`${currentOrigin}/terms`} />}
            </Helmet>
            <StaticPageHeader title="Terms & Conditions" />
            {loading ? loadingView() : error ? errorView(error) : (
                <div className="container static-page-container">
                    <div className="static-page-content">
                        <div dangerouslySetInnerHTML={{ __html: merchantSettings.merchant_configuration?.terms_conditions }} />
                    </div>
                </div>
            )}
        </div>
    )
}

export default TermsConditions;